import { Loader2, RotateCcw } from "lucide-react";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

interface BulkUnarchiveDialogProps {
  isOpen: boolean;
  onClose: () => void;
  selectedDealIds: string[];
  onUnarchive: () => Promise<void>;
  isLoading?: boolean;
}

export const BulkUnarchiveDialog = ({
  isOpen,
  onClose,
  selectedDealIds,
  onUnarchive,
  isLoading = false,
}: BulkUnarchiveDialogProps) => {
  const handleUnarchive = async () => {
    await onUnarchive();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <RotateCcw className="h-5 w-5 text-blue-600" />
            Unarchive {selectedDealIds.length} Deals
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to unarchive {selectedDealIds.length} deals?
            This will restore them to your active deals list and they will
            appear in your main pipeline again.
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <p className="text-sm text-muted-foreground">
            Unarchived deals will be available for normal operations including
            status updates, notes, and AI analysis.
          </p>
        </div>

        <DialogFooter className="flex gap-2">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleUnarchive}
            disabled={isLoading}
            className="bg-blue-600 hover:bg-blue-700"
          >
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Unarchiving...
              </>
            ) : (
              <>
                <RotateCcw className="mr-2 h-4 w-4" />
                Unarchive Deals
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
